<template>
  <div class="collisions-page-title" v-bind:class="[{'map-filter-active': mapFilterActive}]">
    <h1 class="fetch" v-bind:class="[{'is-loading': isLoading}]">
      <div v-if="hasResults">
        <span>{{ collisionsTotalFormatted }}</span> collisions between
        <span>{{ startDate }}</span> and <span>{{ endDate }}</span>
        in <em v-if="mapFilterActive">map area</em> <em v-else="mapFilterActive">all of Seattle</em>
      </div>

      <div v-else>No collisions found matching those filters.</div>
    </h1>

    <div class="loader-dots-wrap center" v-bind:class="[{'is-loading': isLoading}]"><LoaderDots></LoaderDots></div>
  </div>
</template>

<script>
import LoaderDots from '@/components/LoaderDots'
import Moment from 'moment'

export default {
  name: 'pageTitle',

  components: {
    'LoaderDots': LoaderDots
  },

  props: ['resultsFilters'],

  computed: {
    endDate () {
      return Moment(this.resultsFilters.endDate).format('MMMM Do, YYYY')
    },

    startDate () {
      return Moment(this.resultsFilters.startDate).format('MMMM Do, YYYY')
    },

    collisionsTotal () {
      return this.$store.getters['collisionsView/total/get']
    },

    collisionsTotalFormatted () {
      return (this.collisionsTotal.length === 0) ? '' : Number(this.collisionsTotal).toLocaleString('en')
    },

    isLoading () {
      return (this.collisionsTotal.length > 0) ? 0 : 1
    },

    hasResults () {
      return (this.collisionsTotal[0] === -1) ? 0 : 1
    },

    mapFilterActive () {
      return (this.$route.params.m === '1' || this.$route.params.m === 1) ? 1 : 0
    }
  }
}
</script>

<style lang="scss">
@import "./src/sass/components/collisions/PageTitle";
</style>



// WEBPACK FOOTER //
// PageTitle.vue?68f26ce3